import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/config/api'
import { publicAxios } from '@/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query'
import { PublicDto } from '@/types'

const getResellers = (signal?: AbortSignal): Promise<PublicDto['Reseller'][]> =>
  publicAxios.get('/metadata/resellers', { signal })

type QueryFnType = typeof getResellers

type UseGetResellersOptions = {
  config?: QueryConfig<QueryFnType>
}

export const useGetResellers = ({ config }: UseGetResellersOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [QUERY_KEYS.getResellers],
    queryFn: ({ signal }) => getResellers(signal),
  })
}
